import React from 'react';
import { Box, Card, CardContent, CardHeader } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { TemplateTag, TemplateTagGroup } from '../../model/TemplateTag';
import DifficultySelect from './DifficultySelect';
import TemplateTagGroupSelect from './TemplateTagGroupSelect';

// Define the props interface
interface Props {
  templateTags: TemplateTag[];
}

const TemplateConfiguration: React.FC<Props> = ({ templateTags }) => {
  const { control } = useFormContext();
  
  // Use reduce to group templateTags by type
  const templateTagGroups: TemplateTagGroup[] = templateTags.reduce((tagGroups, tag) => {
    // Find existing group for the tag type
    const existingGroup = tagGroups.find(group => group.type === tag.type);

    // If a group exists, add the tag to the existing group, otherwise create a new group
    if (existingGroup) {
      existingGroup.tags.push(tag);
    } else {
      tagGroups.push({ type: tag.type, tags: [tag] });
    }
    console.log("tagGroups", tagGroups)
    return tagGroups;
  }, [] as TemplateTagGroup[]);

  return (
    <Card>
      <CardHeader title="Template Configuration" />
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* Difficulty Selection */}
          <Controller
            name="difficulty"
            control={control}
            rules={{ required: 'Difficulty is required' }}
            render={({ field }) => (
              <DifficultySelect
                difficulty={field.value || ''}
                handleDifficultyChange={(event) => field.onChange(event.target.value)}
              />
            )}
          />

          {/* Template Tags Selection */}
          <Controller
            name="templateTags"
            control={control}
            render={({ field }) => {
              // Convert TemplateTag[] to TemplateTagGroup[] for the component
              const selectedTemplateTagGroups: TemplateTagGroup[] = (field.value || []).reduce((groups: TemplateTagGroup[], tag: TemplateTag) => {
                const existingGroup = groups.find((group: TemplateTagGroup) => group.type === tag.type);
                if (existingGroup) {
                  existingGroup.tags.push(tag);
                } else {
                  groups.push({ type: tag.type, tags: [tag] });
                }
                return groups;
              }, [] as TemplateTagGroup[]);

              return (
                <TemplateTagGroupSelect
                  templateTagGroups={templateTagGroups}
                  selectedTemplateTagGroups={selectedTemplateTagGroups}
                  setSelectedTemplateTagGroups={(newGroups: TemplateTagGroup[]) => {
                    // Convert TemplateTagGroup[] back to TemplateTag[]
                    const flatTags = newGroups.flatMap((group: TemplateTagGroup) => group.tags);
                    field.onChange(flatTags);
                  }}
                />
              );
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default TemplateConfiguration;
